export default "__VITE_ASSET__CchxtcMe__"